let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("baUjQ")).then(() => parcelRequire('1bLay'));